/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import { Disclosures, getState } from '../twd'

const items = require('./resources.json')

const state = getState('corporates.resources', {
    tab: 'why',
    index: 0
})

export default () => {
    const [tab, setTab_] = React.useState(state.value.tab || 'why')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])

    const [index, setIndex_] = React.useState(state.value.index || 0)
    const setIndex = React.useCallback((m) => {
        state.set({index:m})
        setIndex_(m)
    }, [])

    const tabItems = items[tab] || []

    return (
    <React.Fragment>
    <div id='corporate-bond-resources' className="vertical-offset-sm"></div>
    <div data-name='corporate-bond-resources' className="container vertical-offset-sm" css={sectionCss}>

        <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <h3 className="medium-header" style={{marginBottom:0}}>Corporate Bond Resources</h3>
        </div></div>

        <div className="row vertical-offset-sm"><div className="col-xs-12">
        <div data-name='corporates-bond-resources-nav-tabs' className="nav-tabs">
            <ul>
                <li className={tab==='why' ? 'active' : ''}>
                <button
                    data-name='corporates-bond-resources-why-invest-nav-tab'
                    className="subhead"
                    onClick={() => setTab('why')}>Why invest?</button>
                </li>

                <li className={tab==='faq' ? 'active' : ''}>
                <button
                    data-name='corporates-bond-resources-faq-nav-tab'
                    className="subhead"
                    onClick={() => setTab('faq')}>FAQ</button>
                </li>

                <li className={tab==='risk' ? 'active' : ''}>
                <button
                    data-name='corporates-bond-resources-risks-nav-tab'
                    className="subhead"
                    onClick={() => setTab('risk')}>Risks</button>
                </li>
            </ul>
            </div>
        </div></div>

        { Array.isArray(tabItems)
            ? renderItems(tabItems, index, setIndex)
            : renderItem(tabItems) }
    </div>
    </React.Fragment>)
}

const renderItem = ({html, disclosure}) => {
    return <React.Fragment>
        <div className={disclosure ? "row" : "row vertical-offset-sm"}>
            <div className="col-md-12" dangerouslySetInnerHTML={{__html:html}} />
        </div>
        { disclosure && <div className="row vertical-offset-sm">
            <div className="col-md-12 text-right" >
                <Disclosures html={disclosure} />
            </div>
        </div>}
    </React.Fragment>
}


const renderItems = (items, index, setIndex) => items.map((item, idx) => {
    let [title, content] = item
    let showItem = idx === index
    return <React.Fragment key={idx}>
        <div>
        <button
            data-name='corporates-bond-resources-item-arrow'
            data-label={title}
            style={{position:'relative', top:-2, zIndex:1}}
            className="btn-link text-muted"
            onClick={() => setIndex(showItem ? -1 : idx)}>
        <i style={{color:'var(--primary-base-color)'}} className="material-icons">{
            showItem ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
        }</i>
        </button>

        <div style={{position:'relative', top:'-20px', paddingLeft:20}}>
        <button
            data-name='corporates-bond-resources-item-title'
            data-label={title}
            className={ "btn-link text-muted" + (showItem ? " vertical-offset-sm" : '') }
            onClick={() => setIndex(showItem ? -1 : idx)}>
        <b style={{color:'var(--primary-base-color)'}}><span>{title}</span></b>
        </button>

        {showItem && <div css={css} dangerouslySetInnerHTML={{__html:content}} />}
        </div>
        </div>
    </React.Fragment>
})

const css = {

    'li': {
        'padding-left': '10px'
    },
    'img': {
        'max-width': '100%'
    }
}


// WEBPACK FOOTER //
// ./src/corporates/resources.js